import KrpanoViewer from '@/krpanoViewer'
import AframeViewer from '@/aframeViewer'

const VRMaker = {
  AframeViewer,
  KrpanoViewer
}

window.VRMaker = VRMaker
export default VRMaker
